export const ARCHE_ID = 'arche_calendar';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;

/**
 * Width of the hour-label gutter down the left of the time views.
 *
 * The day header, all-day row, and time grid each render their own spacer of
 * this width; if they disagree the columns stop lining up, so they all import
 * this one class string. Narrower on small screens, where 56px is a tenth of
 * the viewport.
 */
export const TIME_GUTTER_CLASS = 'w-11 sm:w-14 shrink-0';
